import React from "react";

const Footer = () => {
  const socialLinks = [
    {
      href: "https://www.facebook.com/dvelgegroup",
      icon: "fab fa-facebook-f",
      label: "Facebook",
    },
    { href: "https://x.com/dvelgegroup", icon: "fab fa-twitter", label: "X" },
    {
      href: "https://www.instagram.com/dvelgegroup",
      icon: "fab fa-instagram",
      label: "Instagram",
    },
    {
      href: "https://www.linkedin.com/company/dvelgegroup",
      icon: "fab fa-linkedin-in",
      label: "Linkedin",
    },
    {
      href: "https://tiktok.com/@dvelgegroup",
      icon: "fab fa-tiktok",
      label: "Tiktok",
    },
    {
      href: "https://www.youtube.com/@dvelgegroup",
      icon: "fab fa-youtube",
      label: "YouTube",
    },
  ];

  const serviceLinks = [
    {
      href: "https://logiciel.dvelgegroup.com",
      label: "Développement logiciel sur mesure",
    },
    {
      href: "https://fourniture.dvelgegroup.com",
      label: "Services d'infrastructure IT",
    },
    {
      href: "https://formation.dvelgegroup.com",
      label: "Formation tech & ateliers",
    },
  ];

  return (
    <footer className="footer-a">
      <div className="footer-fist-row pt40">
        <div className="container">
          <div className="footer-rowset">
            <div className="col footer-head">
              <h5>Coordonnées de contact</h5>
              <ul className="footer-links-list social-linkz">
                <li>
                  <a href="tel:+224623300992">
                    <i className="fas fa-phone-square-alt me-2"></i> +224 623 30
                    09 92
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/224623300992"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-whatsapp-square me-2"></i> +224 623 30
                    09 92
                  </a>
                </li>
                <li>
                  <a href="mailto:info@dvelgegroup.com">
                    <i className="fas fa-envelope me-2"></i>{" "}
                    info@dvelgegroup.com
                  </a>
                </li>
              </ul>
            </div>

            <div className="col footer-head">
              <h5>Suivez-nous</h5>
              <ul className="footer-links-list social-linkz">
                {socialLinks.map((social) => (
                  <li key={social.label}>
                    <a
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={`${social.icon} me-2`}></i> {social.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col footer-head">
              <h5>Services</h5>
              <ul className="footer-links-list">
                {serviceLinks.map((service) => (
                  <li key={service.label}>
                    <a
                      href={service.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {service.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-abt mt70 pt40 pb40">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 vcenter">
                <div className="footer-ree-lg">
                  <div className="footer-logo">
                    <a href="#">
                      <img
                        src="images/footer-logo.png"
                        alt="DVELGE Group"
                        className="img"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 vcenter ft-btn">
                <a href="#" className="ree-btn ree-btn-grdt1 mw-80 no-shadows">
                  Notre Brochure <i className="fas fa-arrow-right fa-btn"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container ft-cpy">
          <div className="row">
            <div className="col-lg-7">
              <div className="ft-copyright ft-r">
                <p>© 2026. All Rights Reserved By DVELGE Group</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
